import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.QXAhtx',
    defaultMessage: 'Container logs',
  },
  titleLabel: {
    id: 'studio.9a9+ww',
    defaultMessage: 'Title',
  },
  noLogs: {
    id: 'studio.EmsQM7',
    defaultMessage: 'No logs found',
  },
  appsembleServer: {
    id: 'studio.vNnC9v',
    defaultMessage: 'Appsemble server logs',
  },
  containerLogs: {
    id: 'studio.s09DoT',
    defaultMessage: 'Logs from container',
  },
  selectContainer: {
    id: 'studio.UFb+xr',
    defaultMessage: 'Select container',
  },
});
